import React, { useEffect } from "react";
import { DeductionDropdown } from "./DeductionDropdown";
import { Trash } from "lucide-react";
import { useGlobalContext } from "../Context/GlobalContext";
export const DeductionsSection = ({
  effectiveDate,
  handleChange,
  deductions,
  setDeductions,
}) => {
  const { baseUrl, selectedStaff } = useGlobalContext();

  const renderMobileView = () => (
    <div className="space-y-4">
      {deductions.map((deduction) => (
        <div
          key={deduction.name}
          className="bg-white rounded-md p-4 border border-gray-200"
        >
          <label className="block text-sm text-[#3A3541] mb-3">
            {deduction.name}
          </label>
          <div className="space-y-3">
            <div className="relative">
              <select
                value={deduction.type}
                onChange={(e) =>
                  handleChange(deduction.name, e.target.value, "type")
                }
                className="w-full text-sm border border-gray-200 block px-3 py-2 rounded-md focus:outline-none appearance-none bg-white"
              >
                <option value="On Attendance">On Attendance</option>
                <option value="Flat Rate">Flat Rate</option>
              </select>
              <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
                <svg
                  className="w-4 h-4 text-gray-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </div>
            </div>
            <div className="relative flex items-center gap-3">
              <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-[#3A3541]">
                ₹
              </span>
              <input
                type="text"
                value={deduction.amount}
                onChange={(e) =>
                  handleChange(deduction.name, e.target.value, "amount")
                }
                placeholder=""
                className="w-full  border border-gray-200 salary-detailcs rounded-md focus:outline-none text-sm"
              />
              <button
                onClick={() =>
                  setDeductions(
                    deductions.filter((item) => item.name !== deduction.name)
                  )
                }
                className="text-red-600 absolute right-[-2px] p-2 hover:bg-gray-100 rounded-md"
              >
                <Trash
                  className="w-4 h-4"
                  onClick={() => {
                    setDeductions(
                      deductions.filter((item) => item.name !== deduction.name)
                    );
                    deleteDeductionField(deduction.id);
                  }}
                />
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );

  const renderTableView = () => (
    <div className="">
      <table className="w-full">
        <thead>
          <tr className="">
            <th className="text-left py-2 text-sm text-[#3A3541] font-medium w-[316px]">
              Heads
            </th>
            <th className="text-left py-2 text-sm text-[#3A3541] font-medium w-1/3">
              Calculation
            </th>
            <th className="text-right py-2 text-sm  text-[#3A3541] font-medium">
              Amount
            </th>
          </tr>
        </thead>
        <tbody>
          {deductions.length === 0 ? (
            <tr>
              <td
                colSpan={3}
                className="py-4 text-sm text-gray-600 font-normal"
              >
                No Deductions Added
              </td>
            </tr>
          ) : (
            deductions.map((deduction) => (
              <tr key={deduction.name} className="group ">
                <td className="py-2">
                  <span className="text-sm text-[#3A3541] font-normal">
                    {deduction.name}
                  </span>
                </td>
                <td className="py-2">
                  <div className="relative w-full md:max-w-[160px]">
                    <select
                      value={deduction.type}
                      onChange={(e) =>
                        handleChange(deduction.name, e.target.value, "type")
                      }
                      className="w-full salary-detailcs text-sm border text-[#3A3541] border-gray-200 rounded-md focus:outline-none appearance-none bg-white"
                    >
                      <option value="On Attendance">On Attendance</option>
                      <option value="Flat Rate">Flat Rate</option>
                    </select>
                    <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
                      <svg
                        className="w-4 h-4 text-gray-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M19 9l-7 7-7-7"
                        />
                      </svg>
                    </div>
                  </div>
                </td>
                <td className="py-2">
                  <div className="flex items-center justify-end gap-2">
                    <div className="relative">
                      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-[#3A3541]">
                        ₹
                      </span>
                      <input
                        type="text"
                        value={deduction.amount || 0}
                        onChange={(e) =>
                          handleChange(deduction.name, e.target.value, "amount")
                        }
                        placeholder="Enter Amount sss"
                        className="w-[160px] bg-white text-right salary-detailcs text-sm font-normal text-[#3A3541] border border-gray-200 rounded-md focus:outline-none "
                      />
                    </div>
                    <button
                      className="absolute right-[-2px]"
                      onClick={() => {
                        setDeductions(
                          deductions.filter(
                            (item) => item.name !== deduction.name
                          )
                        );
                        deleteDeductionField(deduction.id);
                      }}
                    >
                      <Trash className="w-4 h-4 text-red-500" />
                    </button>
                  </div>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
  async function deleteDeductionField(id) {
    const response = await fetch(baseUrl + "deduction/delete/" + id, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

    console.log(response);

    if (response.status === 201) {
      const result = await response.json();
      console.log(result);
      // alert("edit Custom Field Successfully");
    } else {
      // alert("An error occurred");
    }
  }
  async function createNewDeductionField(heads) {
    const data = {};
    const response = await fetch(baseUrl + "deduction/create", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        staffId: selectedStaff?.staffDetails?.id,
        heads: heads,
        deduction_month: effectiveDate,
      }), // send the formatted data
    });

    console.log(response);

    if (response.status === 201) {
      const result = await response.json();
      console.log(result.data);
      setDeductions(
        deductions.map((deduction) =>
          deduction.name === heads
            ? { ...deduction, id: result.data.id }
            : deduction
        )
      );
      // alert("edit Custom Field Successfully");
    } else {
      // alert("An error occurred");
    }
  }

  useEffect(() => {
    if (deductions.length > 0) {
      createNewDeductionField(deductions[deductions.length - 1]?.name);
    }
  }, [deductions.length, effectiveDate]);

  return (
    <div className="w-full">
      <h2 className="bg-[#F4F5F9] text-lg font-medium text-[#3A3541] px-6 py-3 rounded-md">
        Deductions
      </h2>

      <div className="p-[20px] pb-[0]">
        <div className="sm:hidden">{renderMobileView()}</div>
        <div className="hidden sm:block">{renderTableView()}</div>
        <DeductionDropdown
          setDeductions={setDeductions}
          deductions={deductions}
        />
      </div>
    </div>
  );
};
